"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEsriLayer = void 0;
var EL = require("esri-leaflet");
var core_1 = require("@react-leaflet/core");
var createEsriLayer = function (props, context) {
    var instance;
    var layerType = props.layerType, name = props.name;
    switch (layerType) {
        case 'basemapLayer':
            instance = EL.basemapLayer(name, __assign({}, props));
            break;
        default:
            instance = new EL[layerType](__assign({}, props));
    }
    return { instance: instance, context: context };
};
var updateEsriLayer = function (instance, props, prevProps) {
    // basic layer setters for any leaflet layer:
    if (prevProps.url !== props.url) {
        if (instance.setUrl)
            instance.setUrl(props.url);
    }
    if (prevProps.opacity !== props.opacity) {
        if (instance.setOpacity)
            instance.setOpacity(props.opacity);
    }
    if (prevProps.zIndex !== props.zIndex) {
        if (instance.setZIndex)
            instance.setZIndex(props.zIndex);
    }
    // esri leaflet layer setters for all types:
    if (prevProps.to !== props.to || prevProps.from !== props.from) {
        if (instance.setTimeRange)
            instance.setTimeRange(props.to, props.from, props.setTimeCallback || null);
    }
    // feature layer setters:
    if (prevProps.style !== props.style) {
        if (instance.setStyle)
            instance.setStyle(props.style);
    }
    if (prevProps.where !== props.where) {
        if (instance.setWhere)
            instance.setWhere(props.where);
    }
    // dynamic map layer setters:
    if (prevProps.layers !== props.layers) {
        if (instance.setLayers)
            instance.setLayers(props.layers);
    }
    if (prevProps.layerDefs !== props.layerDefs) {
        if (instance.setLayerDefs)
            instance.setLayerDefs(props.layerDefs);
    }
    if (prevProps.dynamicLayers !== props.dynamicLayers) {
        if (instance.setDynamicLayers)
            instance.setDynamicLayers(props.dynamicLayers);
    }
    if (prevProps.timeOptions !== props.timeOptions) {
        if (instance.setTimeOptions)
            instance.setTimeOptions(props.timeOptions);
    }
    // image map layer setters:
    if (prevProps.bandIds !== props.bandIds) {
        if (instance.setBandIds)
            instance.setBandIds(props.bandIds);
    }
    if (prevProps.noData !== props.noData) {
        if (instance.setNoData)
            instance.setNoData(props.bandIds);
    }
    if (prevProps.pixelType !== props.pixelType) {
        if (instance.setPixelType)
            instance.setPixelType(props.bandIds);
    }
    if (prevProps.renderingRule !== props.renderingRule) {
        if (instance.setRenderingRule)
            instance.setRenderingRule(props.renderingRule);
    }
    if (prevProps.mosaicRule !== props.mosaicRule) {
        if (instance.setMosaicRule)
            instance.setMosaicRule(props.mosaicRule);
    }
};
exports.updateEsriLayer = updateEsriLayer;
var EsriLeafletLayer = core_1.createLayerComponent(createEsriLayer, exports.updateEsriLayer);
exports.default = EsriLeafletLayer;
